import request from '@/sheep/request';

// 共愿小组
export interface GroupsMessage {
	userId ?: number
	groupId : number
	nickname : string
	content ?: string
	avatar ?: string
	likeCount ?: number
}

// 创建小组消息
export const createGroupsMessage = async (data : Partial<GroupsMessage>) => {
	return request({
		url: '/wish/groups/message/publish',
		method: 'POST',
		data,
		custom: {
			auth: true,
		},
	});
}

// 获取小组消息列表 分页
export const getGroupsMessagePageOld = async (params ?: any) => {
	return request({
		url: '/wish/groups/message/page',
		method: 'GET',
		params
	});
}

// 获取愿望消息列表 分页
export const getGroupsMessagePage = async (params ?: any) => {
	return request({
		url: '/wish/groups/message/page-root',
		method: 'GET',
		params
	});
}

// 获取愿望消息回复列表 分页
export const getGroupsMessageRepliesPage = async (params ?: any) => {
	return request({
		url: '/wish/groups/message/page-replies',
		method: 'GET',
		params
	});
}

// 获取小组消息列表
export const getGroupsMessageList = async (params ?: any) => {
	return request({
		url: '/wish/groups/message/list',
		method: 'GET',
		params
	});
}

// 消息点赞
export const likeGroupsMessage = async (params : any) => {
	return request({
		url: '/wish/groups/message/like',
		method: 'GET',
		params: params,
		custom: {
			auth: true,
		},
	});
}

// 删除小组评论
export const deleteGroupsMessage = async (id ?: number) => {
	return request({
		url: '/wish/groups/message/delete/' + id,
		method: 'GET',
	});
}